
import { Component, Vue, Prop } from "vue-property-decorator";
import { FormConfig, FormValid } from "@/config";
import InputForm from "@/components/base/form/InputForm.vue";
import { deepClone } from "@/common/utils";
import { Action, Getter } from "vuex-class";
import InfoReplenish from "@/components/InfoReplenish.vue";
@Component({
	name: "BannerCompany",
	components: { InputForm ,InfoReplenish}
})
export default class BannerCompany extends Vue {
	@Prop() data!: any;
	@Action("account/addHomeExtraInfo") private addBasic: any;
	@Prop({ type: Number }) total!: any;

	@Getter("roleSave") private isAuthern: any;
	labelWidth: any = "200px";
	@Getter("company") private company: any;
	@Action("account/getExtraInfo") private getBasic: any;
	@Getter("unitId") private unitId: any;
	labelPosition: any = "top";
	formName: any = "companyBaseInfo";
	rules: any = {
		unitName: [
			{
				required: true,
				trigger: "blur",
				message: "请输入企业名称"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入企业名称"
			}
		],
		organizationType: [
			{
				required: true,
				trigger: "blur",
				message: "请选择企业类型"
			},
			{
				required: true,
				trigger: "change",
				message: "请选择企业类型"
			}
		],
		registeredAddress: [
			{
				required: true,
				trigger: "blur",
				message: "请输入注册地址"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入注册地址"
			}
		],
		theirIndustry: [
			{
				required: true,
				trigger: "blur",
				message: "请选择所属行业"
			},
			{
				required: true,
				trigger: "change",
				message: "请选择所属行业"
			}
		],
		dusinessAddress: [
			{
				required: true,
				trigger: "blur",
				message: "请输入经营地址"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入经营地址"
			}
		],
		detailedAddress: [
			{
				required: true,
				trigger: "blur",
				message: "请输入详细地址"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入详细地址"
			}
		],
		workArea: [
			{
				required: true,
				trigger: "blur",
				message: "请输入办公面积"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入办公面积"
			}
		],
		monthlyRent: [
			{
				required: true,
				trigger: "blur",
				message: "请输入月租金"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入月租金"
			}
		],
		numberCompanies: [
			{
				required: true,
				trigger: "blur",
				message: "请输入企业人数"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入企业人数"
			}
		],
		undergraduateNumber: [
			{
				required: true,
				trigger: "blur",
				message: "请输入本科以上学历人数"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入本科以上学历人数"
			}
		],
		patentNumber: [
			{
				required: true,
				trigger: "blur",
				message: "请输入发明专利"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入发明专利"
			}
		],
		newInventionPatent: [
			{
				required: true,
				trigger: "blur",
				message: "请输入新型发明专利"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入新型发明专利"
			}
		],
		softwareCopyright: [
			{
				required: true,
				trigger: "blur",
				message: "请输入软件著作权"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入软件著作权"
			}
		],
		officeBuildingProperties: [
			{
				required: true,
				trigger: "blur",
				message: "请选择办公楼属性(选框不明)"
			},
			{
				required: true,
				trigger: "change",
				message: "请选择办公楼属性(选框不明)"
			}
		],
		annualTurnover: [
			{
				required: true,
				trigger: "blur",
				message: "请输入年营业额"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入年营业额"
			}
		],
		rdexpenses: [
			{
				required: true,
				trigger: "blur",
				message: "请输入研发费用"
			},
			{
				required: true,
				trigger: "change",
				message: "请输入研发费用"
			}
		],
		iurActivities: [
			{
				required: true,
				trigger: "blur",
				message: "请选择产学研活动"
			},
			{
				required: true,
				trigger: "change",
				message: "请选择产学研活动"
			}
		],
		registeredCapital: [
			{
				required: false,
				trigger: "blur",
				message: "请输入注册资本"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入注册资本"
			}
		],
		foreignCapitalPercentage: [
			{
				required: false,
				trigger: "blur",
				message: "请输入注册资金以及外资(包含港澳台)占比"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入注册资金以及外资(包含港澳台)占比"
			}
		],
		whetherFinance: [
			{
				required: false,
				trigger: "blur",
				message: "请输入是否融资"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入是否融资"
			}
		],
		enterpriseOwnershi: [
			{
				required: false,
				trigger: "blur",
				message: "请选择企业归属(可复选)"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择企业归属(可复选)"
			}
		],
		industryDirection: [
			{
				required: false,
				trigger: "blur",
				message: "请选择产品(服务)所属产业方向(可复选)"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择产品(服务)所属产业方向(可复选)"
			}
		],
		productName: [
			{
				required: false,
				trigger: "blur",
				message: "请输入产品名称"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入产品名称"
			}
		],
		productDescription: [
			{
				required: false,
				trigger: "blur",
				message: "请输入产品介绍"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入产品介绍"
			}
		],
		highTechIndustry: [
			{
				required: false,
				trigger: "blur",
				message: "请选择国家高新技术企业"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择国家高新技术企业"
			}
		],
		recognitionTime: [
			{
				required: false,
				trigger: "blur",
				message: "请输入认定时间"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入认定时间"
			}
		],
		serialNumber: [
			{
				required: false,
				trigger: "blur",
				message: "请输入编号"
			},
			{
				required: false,
				trigger: "change",
				message: "请输入编号"
			}
		],
		smeCertification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择自治区科技型中小企业认定"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择自治区科技型中小企业认定"
			}
		],
		littleCertification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择市级科技小巨人认定"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择市级科技小巨人认定"
			}
		],
		smallMicroCertification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择市级科技型小微企业认定"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择市级科技型小微企业认定"
			}
		],
		iso9000Certification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择通过ISO9000质量体系认证"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择通过ISO9000质量体系认证"
			}
		],
		iso14000Certification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择通过ISO14000质量体系认证"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择通过ISO14000质量体系认证"
			}
		],
		ohsas18000Certification: [
			{
				required: false,
				trigger: "blur",
				message: "请选择通过OHSAS18000职业健康安全体系认证"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择通过OHSAS18000职业健康安全体系认证"
			}
		],
		otherCertifications: [
			{
				required: false,
				trigger: "blur",
				message: "请选择其他认证"
			},
			{
				required: false,
				trigger: "change",
				message: "请选择其他认证"
			}
		]
	};
	formSetting: any = [
		{
			label: "企业名称",
			ref: "unitName",
			type: "input",
			span: 12,
			disabled: true,
			required: false,
			index: 1
		},
		{
			label: "企业类型",
			type: "input",
			ref: "organizationType",
			options: FormConfig.unit_type,
			span: 12,
			disabled: true,
			required: false,
			index: 4
		},
		{
			label: "注册地址",
			ref: "registeredAddress",
			span: 12,
			type: "input",
			disabled: true,
			required: false,
			index: 8
		},
		{
			label: "所属行业",
			ref: "theirIndustry",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: true,
			required: false,
			index: 5
		},
		{
			label: "经营地址",
			ref: "dusinessAddress",
			span: 12,
			type: "input",
			disabled: false,
			required: false,
			index: 7
		},
		{
			label: "详细地址",
			ref: "detailedAddress",
			span: 12,
			type: "input",
			disabled: false,
			required: false,
			index: 7
		},
		{
			label: "办公面积",
			ref: "workArea",
			span: 12,
			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "月租金",
			ref: "monthlyRent",
			span: 12,
			options: FormConfig.industry,

			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "企业人数",
			ref: "numberCompanies",
			span: 12,
			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "本科以上学历人数",
			ref: "undergraduateNumber",
			span: 12,
			options: FormConfig.industry,

			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "发明专利",
			ref: "patentNumber",
			span: 12,
			options: FormConfig.industry,

			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "新型发明专利",
			ref: "newInventionPatent",
			span: 12,
			options: FormConfig.industry,

			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "软件著作权",
			ref: "softwareCopyright",
			span: 12,
			options: FormConfig.industry,

			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "办公楼属性(选框不明)",
			ref: "officeBuildingProperties",
			span: 12,
			options: FormConfig.industry,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "年营业额",
			ref: "annualTurnover",
			span: 12,
			options: FormConfig.industry,
			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "研发费用",
			ref: "rdexpenses",
			span: 12,
			options: FormConfig.industry,

			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "产学研活动",
			ref: "iurActivities",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "注册资本",
			ref: "registeredCapital",
			span: 12,
			disabled: false,
			type: "input",
			required: false,
			index: 9
		},
		{
			label: "注册资金以及外资(包含港澳台)占比",
			ref: "foreignCapitalPercentage",
			span: 12,
			type: "inputnumber",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "是否融资",
			ref: "whetherFinance",
			span: 12,
			options: FormConfig.industry,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "企业归属(可复选)",
			ref: "enterpriseOwnershi",
			span: 12,
			options: FormConfig.enterpriseOwnershi,
			props: { multiple: true },
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "产品(服务)所属产业方向(可复选)",
			ref: "industryDirection",
			span: 12,
			options: FormConfig.industryDirection,
			props: { multiple: true },
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "产品名称",
			ref: "productName",
			span: 12,
			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "产品介绍",
			ref: "productDescription",
			span: 12,
			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "国家高新技术企业",
			ref: "highTechIndustry",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "认定时间",
			ref: "recognitionTime",
			span: 12,
			type: "time",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "编号",
			ref: "serialNumber",
			span: 12,
			options: FormConfig.industry,

			type: "input",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "自治区科技型中小企业认定",
			ref: "smeCertification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "市级科技小巨人认定",
			ref: "littleCertification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "市级科技型小微企业认定",
			ref: "smallMicroCertification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "通过ISO9000质量体系认证",
			ref: "iso9000Certification",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "通过ISO14000质量体系认证",
			ref: "iso14000Certification",
			span: 12,
			options: FormConfig.yes_no,

			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "通过OHSAS18000职业健康安全体系认证",
			ref: "ohsas18000Certification",
			span: 12,
			options: FormConfig.yes_no,

			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		},
		{
			label: "其他认证",
			ref: "otherCertifications",
			span: 12,
			options: FormConfig.yes_no,
			type: "cascader",
			disabled: false,
			required: false,
			index: 5
		}
	];
	formData: any = {};
	save() {
		const cascaderList = [
			"enterpriseOwnershi",
			"industryDirection",
			"officeBuildingProperties",
			"iurActivities",
			"highTechIndustry",
			"smeCertification",
			"littleCertification",
			"smallMicroCertification",
			"iso9000Certification",
			"iso14000Certification",
			"ohsas18000Certification",
			"otherCertifications",
			"whetherFinance"
		];
		let properties = deepClone(this.formData);
 
		for (let property in properties) {
			if (cascaderList.includes(property)) {
				properties[property] = properties[property].join(",");
			}
		}
		const options = {
			id: properties.id,
			...properties
		};
		if (!options.id) {
			return this.handleClose();
		}
		this.addBasic(options).then(({ code, data, msg }: any) => {
			if (code === 0) {
				this.$message.success("提交成功");
				this.handleClose();
				return data;
			}
		});
	}
	isVisible = false;
	showDialog() {
        console.log(this.data)
		// this.isVisible = true;
        this.$refs.InfoReplenish.show(this.data);
        
		// this.getSaveData();
	}
	handleClose() {
		// this.isVisible = false;
	}
	async getSaveData() {
		const currentData = await this.data;
		this.$emit("update:data", currentData);
		const {
			unitName,
			cate_1: theirIndustry,
			company_org_type: organizationType,
			reg_location: registeredAddress
		} = currentData;
		this.formData = {
			unitName,
			organizationType,
			registeredAddress,
			theirIndustry
		};
	}
	async mounted() {
        
		this.getSaveData();
	}
}
